type Color = string
type Tag = string

const GOLDEN_ANGLE = 137.508 // evenly spaced hues

function hslToHex(h: number, s: number, l: number): Color {
  s /= 100
  l /= 100
  const k = (n: number) => (n + h / 30) % 12
  const a = s * Math.min(l, 1 - l)
  const f = (n: number) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))
  const toHex = (x: number) =>
    Math.round(255 * x)
      .toString(16)
      .padStart(2, '0')
  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`
}

// Generates a unique color when palette is exhausted
function generateNewColor(used: Set<Color>, seed: number): Color {
  let i = seed
  for (;;) {
    const hue = (i * GOLDEN_ANGLE) % 360
    const candidate = hslToHex(hue, 65, 55)
    if (!used.has(candidate)) return candidate
    i++
  }
}

export function assignTagColors(
  uniqueTags: Tag[],
  GraphColors: Color[],
  MediaTagsColors: Record<Tag, Color> = {}
): Record<Tag, Color> {
  const result: Record<Tag, Color> = { ...MediaTagsColors }
  const used = new Set<Color>(Object.values(result).filter(Boolean))

  let colorIndex = 0
  let generatedSeed = used.size

  for (const tag of uniqueTags) {
    if (result[tag]) continue // already assigned, keep it

    // Find next free palette color
    while (
      colorIndex < GraphColors.length &&
      used.has(GraphColors[colorIndex])
    ) {
      colorIndex++
    }

    const color =
      colorIndex < GraphColors.length
        ? GraphColors[colorIndex++]
        : generateNewColor(used, generatedSeed++)

    result[tag] = color
    used.add(color)
  }

  return result
}
